import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { navigation, siteInfo } from '@/mocks/site';

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-spy-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              {siteInfo.intro}
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-background-400">
              <i className="ri-calendar-line" />
              {siteInfo.founded}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">主题分类</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/topics?cat=${cat.id}`}
                    className="text-background-300 transition-colors hover:text-primary-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">站点导航</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {navigation.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-background-300 transition-colors hover:text-primary-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <a href="#subscribe" className="text-background-300 transition-colors hover:text-primary-300">
                  订阅爆料速递
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-300" />
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-hand-coin-line text-primary-300" />
                {siteInfo.cooperation}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-300" />
                工作日 10:00 - 18:00 回复
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-800/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} {siteInfo.fullName} 保留所有权利
          </p>
          <p className="text-xs text-background-400">
            内容基于公开信息整理 · 理性讨论 · 拒绝谣言
          </p>
        </div>
      </div>
    </footer>
  );
}